import { useEffect } from "react"
import { MainTable } from "../../Components/MainTable/MainTable"
import { useDiscount } from "./DiscountStore"
import Add from "./Add"
import Edit from "./Edit"

function Discounts() {
    const { discounts, columns, getDiscounts, setEd } = useDiscount()
    useEffect(() => {
        getDiscounts()
    }, [])
    return (
        <MainTable 
            pageTitle="Chegirma kodlari"
            pcolumns={columns}
            pdata={discounts}
            defkey={'id'}
            add={<Add />}
            edit={<Edit />}
            onEdit={(rec) => setEd(rec)}
            setEd={setEd}
        />
    )
}

export default Discounts
